import { gql } from "@apollo/client";

export const ADD_ADVERTISE = gql`
mutation Mutation($input: blog) {
  addBlog(input: $input) {
    status
    message
  }
}
`

export const DELETE_ADvertise = gql`
mutation DeleteBlog($deleteBlogId: ID) {
  deleteBlog(id: $deleteBlogId)
}
`

export const ADD_PINCODE_DATA_OF_FRANCHISE = gql`
mutation($file: Upload!) {
  uploadPincodeData(file: $file) {
    success
    message
    uploadedCount
    errors
  }
}
`